import { Skeleton, Tag } from 'antd';
import compact from 'lodash/compact';
import compose from 'lodash/fp/compose';
import mapFP from 'lodash/fp/map';
import uniqByFP from 'lodash/fp/uniqBy';
import reduce from 'lodash/reduce';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetRoles } from '@/modules/admin/hooks/useRol';
import { i18n } from '@/settings';

const roleRender = (role, t) => {
  const roleName = role?.name;
  const exist = i18n.exists(`admin:rol.${roleName}`);
  const title = exist ? t(`rol.${roleName}`) : roleName;

  let color;
  switch (roleName) {
    case 'SUPER_ADMIN':
      color = 'blue';
      break;
    default:
      color = '';
      break;
  }
  return (
    <Tag key={role?._id} color={color}>
      <span className={'flex-grow'}>{title}</span>
    </Tag>
  );
};

const UserRoles = ({ value }) => {
  const { t } = useTranslation('admin');
  const { data, isLoading } = useGetRoles();

  const dict = useMemo(() => reduce(data, (acc, item) => {
    acc[item?.id] = item?.name;
    return { ...acc };
  }, {}), [data]);

  const rolesView = useMemo(() => compose(
    compact,
    mapFP((item) => roleRender(item, t)),
    uniqByFP('_id'),
    mapFP((item) => {
      if (item?.name) return item;
      return { name: dict[item], _id: item };
    }),
  )(value), [value, t, dict]);

  return (
    <div className={'flex flex-row items-center'}>
      <Skeleton loading={isLoading} active paragraph={false}>
        {rolesView}
      </Skeleton>
    </div>
  );
};

UserRoles.propTypes = {
  value: PropTypes.array
};

UserRoles.defaultProps = {
  value: []
};

export default memo(UserRoles);
